export default function (widget) {
    const m = widget.m;
    const state = widget.state;
    const t = widget.txt;

    const ns = widget.ns + '__currentvalue';

    const currentvalue = {
        controller: function (/*props*/) {
            const ctrl = this;

            ctrl.recentlyChanged = false;
            let lastTimepointTime = 0;
            state.on('timepoint', function () {
                const timepoint = state.timepoint;
                if (timepoint && timepoint.time !== lastTimepointTime) {
                    lastTimepointTime = timepoint.time;
                    // Set (and then reset) recentlyChanged flag
                    clearTimeout(ctrl.recentlyChanged);
                    ctrl.recentlyChanged = setTimeout(function () {
                        ctrl.recentlyChanged = false;
                        m.redraw();
                    }, 500);
                }
            });
            ctrl.cursorOffset = function () {
                return 0;
            };


            // var last = {};
            ctrl.maySkipRendering = function () {
                // var maySkip = state.timepoint === last.timepoint && state.isAutoPlaying === last.isAutoPlaying;
                // last.timepoint = state.timepoint;
                // last.isAutoPlaying = state.isAutoPlaying;
                // return maySkip;
            };
        },


        view: function (ctrl/*, props*/) {
            // ctrl.props = props || {};

            if (ctrl.maySkipRendering()) {
                return {subtree: 'retain'};
            }

            const timepoint = state.timepoint;
            const leftOffset = 'left:' + 100 * ctrl.cursorOffset() + '%';
            const changedClass = ctrl.recentlyChanged ? ns + '--changed' : '';

            return (
                m('div', {className: ns + '-container'},
                    m('time', {
                            className: ns + '' + changedClass,
                            datetime: timepoint.isoDate,
                            style: leftOffset,
                        },
                        m('span', {className: ns + '__label'}, t('$timeline__timelabel')),
                        timepoint.hours + ':' + timepoint.minutes0
                    ),
                    m('div', {className: ns + '__cursor', style: leftOffset})
                )
            );

        },

    };


    return currentvalue;
}
